import { error, misc, neutral, success } from "../app/themes/colors";
import EnumDataSource from "../utils/enum-data-source.util";

export const INVENTORY_PRODUCT_STATUS_PRESCRIBED = 1;
export const INVENTORY_PRODUCT_STATUS_ORDERED = 2;
export const INVENTORY_PRODUCT_STATUS_AWAITING_CONFIRMATION = 3;
export const INVENTORY_PRODUCT_STATUS_SHIPPED = 4;
export const INVENTORY_PRODUCT_STATUS_IN_TRANSIT = 5;
export const INVENTORY_PRODUCT_STATUS_RECEIVED = 6;
export const INVENTORY_PRODUCT_STATUS_CUSTOMS_CLEARANCE = 7;
export const INVENTORY_PRODUCT_STATUS_IN_STOCK = 8;
export const INVENTORY_PRODUCT_STATUS_RESERVED = 9;
export const INVENTORY_PRODUCT_STATUS_QUALITY_CONTROL = 10;
export const INVENTORY_PRODUCT_STATUS_SOLD = 11;
export const INVENTORY_PRODUCT_STATUS_ON_LOAN = 12;
export const INVENTORY_PRODUCT_STATUS_ON_DEMO = 13;
export const INVENTORY_PRODUCT_STATUS_RETURNED = 14;
export const INVENTORY_PRODUCT_STATUS_REPAIR_ACCEPTED = 15;
export const INVENTORY_PRODUCT_STATUS_REPAIR_SENT = 16;
export const INVENTORY_PRODUCT_STATUS_TRANSFERRED_OUT = 17;
export const INVENTORY_PRODUCT_STATUS_TRANSFERRED_IN = 18;
export const INVENTORY_PRODUCT_STATUS_BACKORDERED = 19;
export const INVENTORY_PRODUCT_STATUS_DELAYED = 20;
export const INVENTORY_PRODUCT_STATUS_QUARANTINE = 21;
export const INVENTORY_PRODUCT_STATUS_CANCELED = 22;
export const INVENTORY_PRODUCT_STATUS_RETIRED = 23;
export const INVENTORY_PRODUCT_STATUS_RETURNED_TO_MANUFACTURER = 24;

const status = {
  [INVENTORY_PRODUCT_STATUS_PRESCRIBED]: "Prescribed",
  [INVENTORY_PRODUCT_STATUS_ORDERED]: "Ordered",
  [INVENTORY_PRODUCT_STATUS_AWAITING_CONFIRMATION]: "Awaiting Confirmation",
  [INVENTORY_PRODUCT_STATUS_SHIPPED]: "Shipped",
  [INVENTORY_PRODUCT_STATUS_IN_TRANSIT]: "In Transit",
  [INVENTORY_PRODUCT_STATUS_RECEIVED]: "Received",
  [INVENTORY_PRODUCT_STATUS_CUSTOMS_CLEARANCE]: "Customs Clearance",
  [INVENTORY_PRODUCT_STATUS_IN_STOCK]: "In Stock",
  [INVENTORY_PRODUCT_STATUS_RESERVED]: "Reserved",
  [INVENTORY_PRODUCT_STATUS_QUALITY_CONTROL]: "Quality Control",
  [INVENTORY_PRODUCT_STATUS_SOLD]: "Sold",
  [INVENTORY_PRODUCT_STATUS_ON_LOAN]: "On Loan",
  [INVENTORY_PRODUCT_STATUS_ON_DEMO]: "On Demo",
  [INVENTORY_PRODUCT_STATUS_RETURNED]: "Returned to Clinic",
  [INVENTORY_PRODUCT_STATUS_RETURNED_TO_MANUFACTURER]:
    "Returned to Manufacturer",
  [INVENTORY_PRODUCT_STATUS_REPAIR_ACCEPTED]: "Repair Accepted",
  [INVENTORY_PRODUCT_STATUS_REPAIR_SENT]: "Repair Sent",
  [INVENTORY_PRODUCT_STATUS_TRANSFERRED_OUT]: "Transferred Out",
  [INVENTORY_PRODUCT_STATUS_TRANSFERRED_IN]: "Transferred In",
  [INVENTORY_PRODUCT_STATUS_BACKORDERED]: "Backordered",
  [INVENTORY_PRODUCT_STATUS_DELAYED]: "Delayed",
  [INVENTORY_PRODUCT_STATUS_QUARANTINE]: "Quarantine",
  [INVENTORY_PRODUCT_STATUS_CANCELED]: "Canceled",
  [INVENTORY_PRODUCT_STATUS_RETIRED]: "Retired"
};

export const INVENTORY_PRODUCT_STATUSES = new EnumDataSource(status);

export const INVENTORY_PRODUCT_STATUS_COLORS: Record<number, string> = {
  [INVENTORY_PRODUCT_STATUS_PRESCRIBED]: error[400],
  [INVENTORY_PRODUCT_STATUS_ORDERED]: neutral[500],
  [INVENTORY_PRODUCT_STATUS_AWAITING_CONFIRMATION]: misc.darkYellow,
  [INVENTORY_PRODUCT_STATUS_SHIPPED]: neutral[500],
  [INVENTORY_PRODUCT_STATUS_IN_TRANSIT]: neutral[500],
  [INVENTORY_PRODUCT_STATUS_RECEIVED]: success[600],
  [INVENTORY_PRODUCT_STATUS_CUSTOMS_CLEARANCE]: neutral[500],
  [INVENTORY_PRODUCT_STATUS_IN_STOCK]: success[600],
  [INVENTORY_PRODUCT_STATUS_RESERVED]: error[400],
  [INVENTORY_PRODUCT_STATUS_QUALITY_CONTROL]: misc.darkYellow,
  [INVENTORY_PRODUCT_STATUS_SOLD]: success[600],
  [INVENTORY_PRODUCT_STATUS_ON_LOAN]: success[600],
  [INVENTORY_PRODUCT_STATUS_ON_DEMO]: success[600],
  [INVENTORY_PRODUCT_STATUS_RETURNED]: neutral[500],
  [INVENTORY_PRODUCT_STATUS_REPAIR_ACCEPTED]: error[400],
  [INVENTORY_PRODUCT_STATUS_REPAIR_SENT]: neutral[500],
  [INVENTORY_PRODUCT_STATUS_TRANSFERRED_OUT]: misc.grayAsphalt,
  [INVENTORY_PRODUCT_STATUS_TRANSFERRED_IN]: misc.grayAsphalt,
  [INVENTORY_PRODUCT_STATUS_BACKORDERED]: success[600],
  [INVENTORY_PRODUCT_STATUS_DELAYED]: error[400],
  [INVENTORY_PRODUCT_STATUS_QUARANTINE]: misc.darkYellow,
  [INVENTORY_PRODUCT_STATUS_CANCELED]: misc.darkYellow,
  [INVENTORY_PRODUCT_STATUS_RETIRED]: neutral[500]
};

export const QUICK_FILTER_DEFAULT_TYPE: string = "0";
export const QUICK_FILTER_READY_TO_CHECK_IN: string = "1";
export const QUICK_FILTER_READY_TO_BE_DELIVERED: string = "2";
export const QUICK_FILTER_IN_REPAIR: string = "3";
export const QUICK_FILTER_ORDERED: string = "4";
export const QUICK_FILTER_HEARING_AIDS: string = "5";
export const QUICK_FILTER_ACCESSORIES: string = "6";
export const QUICK_FILTER_SUPPLIES: string = "7";
export const QUICK_FILTER_OUT_OF_STOCK: string = "8";
export const QUICK_FILTER_LOANERS: string = "9";
export const QUICK_FILTER_DEMOS: string = "10";
export const QUICK_FILTER_STOCK: string = "11";

const inventoryProductsQuickFiltersType = {
  [QUICK_FILTER_DEFAULT_TYPE]: "All",
  [QUICK_FILTER_READY_TO_CHECK_IN]: "Ready to Check-In",
  [QUICK_FILTER_READY_TO_BE_DELIVERED]: "Ready to be Delivered",
  [QUICK_FILTER_IN_REPAIR]: "In Repair",
  [QUICK_FILTER_ORDERED]: "Ordered",
  [QUICK_FILTER_LOANERS]: "Loaners",
  [QUICK_FILTER_DEMOS]: "Demos"
};

export const QUICK_FILTER_TYPES = new EnumDataSource(
  inventoryProductsQuickFiltersType
);

const clinicStockQuickFiltersType = {
  [QUICK_FILTER_DEFAULT_TYPE]: "All",
  [QUICK_FILTER_HEARING_AIDS]: "Hearing Aids",
  [QUICK_FILTER_ACCESSORIES]: "Accessories",
  [QUICK_FILTER_SUPPLIES]: "Supplies",
  [QUICK_FILTER_OUT_OF_STOCK]: "Out of Stock",
  [QUICK_FILTER_STOCK]: "Stock",
  [QUICK_FILTER_LOANERS]: "Loaners",
  [QUICK_FILTER_DEMOS]: "Demos"
};

export const CLINIC_STOCK_QUICK_FILTER_TYPES = new EnumDataSource(
  clinicStockQuickFiltersType
);
export const INVENTORY_CONDITION_ALL = 0;
export const INVENTORY_CONDITION_NEW = 1;
export const INVENTORY_CONDITION_REFURBISHED = 2;
export const INVENTORY_CONDITION_USED = 3;
export const INVENTORY_CONDITION_LOANER = 3;
export const INVENTORY_CONDITION_DEMO = 4;

const inventoryItemConditions = {
  [INVENTORY_CONDITION_NEW]: "New",
  [INVENTORY_CONDITION_REFURBISHED]: "Refurbished",
  [INVENTORY_CONDITION_USED]: "Used"
};

export const INVENTORY_ITEM_CONDITIONS = new EnumDataSource(
  inventoryItemConditions
);

// Server-paginated page size for inventory product autocomplete pickers
// (`<InventoryProductField>` and the From-Stock branch of `<ProductSearch>`).
// Paired with `useGetInventoryProductsCountQuery` to surface a "type to search
// for more" hint inside the listbox Paper when the server has more matches.
// Smaller than the tag picker's 100 (constants/tags.ts) — inventory catalogs
// are larger and we want the search affordance to surface earlier.
export const INVENTORY_PRODUCT_AUTOCOMPLETE_PAGE_SIZE = 25;
